import InputToast from './InputToast';

export default InputToast;
